import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="appointments"
export default class extends Controller {
  connect() {
    const stayOnFormValues = this.element.querySelector('#stay-on-form').dataset;
    const radioButtons = this.element.querySelectorAll('input.form-check-input[name="appointment[increment_start_time]"]');
    radioButtons.forEach(radioButton => {
      radioButton.addEventListener('click', () => {
        const stayOnFormValue = stayOnFormValues[radioButton.value];
        const stayOnFormCheckbox = this.element.querySelector('input#appointment_stay_on_form');
        const canStayOnForm = stayOnFormValue == 'true';
        stayOnFormCheckbox.checked = canStayOnForm;
        stayOnFormCheckbox.disabled = !canStayOnForm;
      });
    });
  }
}
